import { BankQueryKeys } from '@/modules/bank/keys'
import { useQuery } from '@tanstack/react-query'
import { getPaymentGatewayConstraints } from '../../services'

export default function useQueryGetPaymentGatewayConstraints() {
	return useQuery({
		queryKey: [BankQueryKeys.PaymentGatewayConstraints],
		queryFn: () => getPaymentGatewayConstraints(),
	})
}
